// Canais de contato centralizados num só lugar (PDF §8: "número e textos
// configuráveis, não hardcoded").

// Telefone fixo para ligação — o mesmo publicado em SectionContato.vue/Footer.vue.
export const TELEFONE_DISPLAY = process.env.VUE_APP_TELEFONE || '(41) 3205-1333';
const TELEFONE_TEL = (process.env.VUE_APP_TELEFONE_TEL || '554132051333').replace(/\D/g, '');
export const telUrl = `tel:+${TELEFONE_TEL}`;

export const WHATSAPP_MSG_PADRAO =
  'Olá! Acessei o site da Creditall e gostaria de saber mais sobre as soluções para minha empresa.';

// WhatsApps do time comercial. São dois canais distintos, então a interface
// oferece a escolha em vez de decidir por conta própria (spec §11).
export const WHATSAPPS_COMERCIAL = [
  { ddd: '41', display: '(41) 99816-6966', numero: '5541998166966' },
  { ddd: '44', display: '(44) 98845-9173', numero: '5544988459173' },
];

// Monta o link do WhatsApp para um número, com mensagem pré-preenchida.
export function whatsappUrl(numero, mensagem = WHATSAPP_MSG_PADRAO) {
  const n = String(numero || WHATSAPPS_COMERCIAL[0].numero).replace(/\D/g, '');
  return `https://wa.me/${n}?text=${encodeURIComponent(mensagem)}`;
}
